<template>
    <div v-if="Object.keys(formattedOpeningHours).length" class="etx-text Text" :class="class">
        <p class="font-weight-bold">{{ $texts('opening_hours', 'Öffnungszeiten') }}</p>

        <div class="Table opening-hours">
            <table>
                <tbody>
                    <template v-for="(hours, days) in formattedOpeningHours" :key="days">
                        <tr>
                            <td>{{ days }}</td>
                            <td>{{ hours[0].starthours }} - {{ hours[0].endhours }}</td>
                        </tr>
                        <tr v-for="(hour, index) in hours.slice(1)" :key="index">
                            <td></td>
                            <td>{{ hour.starthours }} - {{ hour.endhours }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
    class?: string[]
    openingHours?: object
}>()

const formattedOpeningHours = computed(() => formatOpeningHours(props.openingHours));

const { $texts } = useNuxtApp()

function formatOpeningHours(openingHours) {
    const daysOfWeek = [
        $texts('label_monday', 'Montag'),
        $texts('label_tuesday', 'Dienstag'),
        $texts('label_wednesday', 'Mittwoch'),
        $texts('label_thursday', 'Donnerstag'),
        $texts('label_friday', 'Freitag'),
        $texts('label_saturday', 'Samstag'),
        $texts('label_sunday', 'Sonntag')
    ];

    const groupedHours = openingHours.reduce((acc, { day, starthours, endhours }) => {
        const dayName = daysOfWeek[day - 1];
        if (!acc[dayName]) {
            acc[dayName] = [];
        }
        acc[dayName].push({ starthours, endhours });
        return acc;
    }, {});

    const result = {};
    let currentGroup = { days: [], hours: '' };

    Object.entries(groupedHours).forEach(([day, hours], index, array) => {
        const formattedHours = JSON.stringify(hours);

        if (currentGroup.hours === formattedHours) {
            currentGroup.days.push(day);
        } else {
            if (currentGroup.days.length > 0) {
                const daysRange = currentGroup.days.length > 1 ? `${currentGroup.days[0]} - ${currentGroup.days[currentGroup.days.length - 1]}` : currentGroup.days[0];
                result[daysRange] = formatHours(JSON.parse(currentGroup.hours));
            }
            currentGroup = { days: [day], hours: formattedHours };
        }

        if (index === array.length - 1) {
            const daysRange = currentGroup.days.length > 1 ? `${currentGroup.days[0]} - ${currentGroup.days[currentGroup.days.length - 1]}` : currentGroup.days[0];
            result[daysRange] = formatHours(JSON.parse(currentGroup.hours));
        }
    });

    return result;
}

function formatHours(hours) {
    return hours.map(({ starthours, endhours }) => ({
        starthours: `${String(starthours).padStart(4, '0').slice(0, 2)}.${String(starthours).padStart(4, '0').slice(2)}`,
        endhours: `${String(endhours).padStart(4, '0').slice(0, 2)}.${String(endhours).padStart(4, '0').slice(2)}`
    }));
}
</script>

<style lang="postcss">
.Table.opening-hours td {
    white-space: nowrap;
}
</style>